import { z } from 'zod';
import { Contact, TextItem } from './common';
export var SupporterTypeEnum = {
    PARTNER: 'PARTNER',
    CHEERLEADER: 'CHEERLEADER',
    POSITIVE_ENABLER: 'POSITIVE_ENABLER'
};
export var SupportActivity = TextItem;
export var Supporter = z.object({
    contact: Contact,
    type: z.nativeEnum(SupporterTypeEnum),
    activities: z.array(SupportActivity)
});
export var DetractorStrategy = TextItem;
export var Detractor = z.object({
    contact: Contact,
    strategies: z.array(DetractorStrategy)
});
export var SocialSupport = z.object({
    supporters: z.array(Supporter),
    detractors: z.array(Detractor)
}).prefault({
    supporters: [],
    detractors: []
});
